<template>
  <div>
    <Upload
      :accept="accept"
      :action="uploadUrl"
      :headers="headers"
      :multiple="multiple"
      :show-upload-list="false"
      :data="data"
      type="drag"
      :before-upload="beforeUpload"
      :on-success="success"
      :on-error="error">
      <div style="padding: 20px 0">
        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
        <p>选择文件上传导入</p>
      </div>
    </Upload>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { API_ENDPOINT } from '@/config'

export default {
  name: 'upload-file',
  props: {
    accept: {
      type: String,
      default: '*'
    },
    url: {
      type: String,
      default: ''
    },
    responseFilter: {
      type: Function,
      default: function () {}
    },
    multiple: {
      type: Boolean,
      default: false
    },
    data: Object,
    text: String,
    tip: String,
    change: Function
  },
  data () {
    return {
      image: null,
      headers: {}
    }
  },
  computed: {
    ...mapGetters([
      'loginedToken'
    ]),
    uploadUrl () {
      return API_ENDPOINT + this.url
    }
  },
  beforeMount () {
    this.headers['X-Access-Token'] = this.loginedToken
  },
  methods: {
    beforeUpload (file) {
      this.$emit('before-upload', file)
      this.$Spin.show()
    },
    success (response, file, fileList) {
      this.$emit('input', fileList)
      this.$emit('change', fileList)
      this.$emit('success', response, file, fileList)
      this.$Spin.hide()
    },
    error (err, file, fileList) {
      if (err.status === 422) this.$Message.error(file.message)
      this.$emit('error', err, file, fileList)
      this.$Spin.hide()
    }
  }
}
</script>

<style scoped lang="scss">
</style>
